import React, { useState, useMemo, useEffect, useRef } from "react";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "@vtaits/react-color-picker/dist/index.css";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom';
import PropTypes, { func } from "prop-types";
import {
    Container,
    Button,
    Col,
    Row,
    UncontrolledTooltip,
    Label,
    Card,
    CardBody,
    CardTitle,
    Input
} from "reactstrap";
import Select from "react-select";
import TableContainer from '../../../components/Common/TableContainer';
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
    getCompanies as onGetCompanies,
    getPeriods as onGetPeriods,
    getListAccount as onGetAccounts,
    getListAccountNumber as onGetAccountNumbers,
    getListAccountTransactionDraft as onGetAccountTransactionDrafts,
    deleteAccountTransactionDraft as onDeleteAccountTransactionDraft,
    clearPeriods as onClearPeriods,
    clearListAccount as onClearListAccount,
    clearListAccountNumber as onClearListAccountNumber,
    clearListAccountTransactionDraft as onClearListAccountTransactionDraft,
    exportExcelAccountTransaction as onExportExcelAccountTransaction,
    updateAccountTransactionDraft as onUpdateAccountTransactionDraft
} from "../../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";
import CurrencyFormat from 'react-currency-format';
import { upperCase } from "lodash";
import ModalEdit from "./modalEdit";
import DeleteModal from "../../../components/Common/ModalDelete";

const AccountClassification = () => {

    //meta title
    document.title = "Transaction | Account Classification | Des Counts";

    const dispatch = useDispatch();
    const [accountTransactionDraft, setAccountTransactionDraft] = useState(null)
    const [totalSelected, setTotalSelected] = useState(0)
    const [isOpenDelete, setIsOpenDelete] = useState(false)
    const [remarks, setRemarks] = useState("")
    const [tglMulaiFilter, setTglMulaiFilter] = useState(null)
    const [tglSampaiFilter, setTglSampaiFilter] = useState(null);

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [optionCompany, setOptionCompany] = useState([]);
    function handleSelectCompany(e) {
        setSelectedCompany(e);
    }
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [optionPeriod, setOptionPeriod] = useState([]);
    function handleSelectPeriod(e) {
        setSelectedPeriod(e);
    }

    const [selectedAccountNumber, setSelectedAccountNumber] = useState(null);
    const [optionAccountNumber, setOptionAccountNumber] = useState([]);
    function handleSelectAccountNumber(e) {
        setSelectedAccountNumber(e);
    }
    const [selectedType, setSelectedType] = useState(null);
    const [optionType] = useState([
        { label: "DEBIT", value: "debit" },
        { label: "CREDIT", value: "credit" },
    ]);
    function handleSelectType(e) {
        setSelectedType(e);
    }

    function handleDateRangeChange(e) {
        if (e.length == 2) {
            const dd = e[0].getDate().toString();
            const mm = e[0].getMonth() + 1;
            const yyyy = e[0].getFullYear();
            setTglMulaiFilter(String(yyyy).padStart(2, '0') + "-" + String(mm).padStart(2, '0') + "-" + String(dd).padStart(2, '0'))
            const dd2 = e[1].getDate().toString();
            const mm2 = e[1].getMonth() + 1;
            const yyyy2 = e[1].getFullYear();
            setTglSampaiFilter(String(yyyy2).padStart(2, '0') + "-" + String(mm2).padStart(2, '0') + "-" + String(dd2).padStart(2, '0'))
        }
        else {
            setTglMulaiFilter(null)
            setTglSampaiFilter(null)
        }
    }

    const filterCompany = useRef("");
    const filterPeriod = useRef("");
    const filterAccountNumber = useRef("");
    const filterDateRange = useRef(null);
    const filterType = useRef("");
    const filterRemarks = useRef(null);

    const {
        companies,
        loadingCompany,
        periods,
        loadingPeriod,
        accounts,
        loadingAccount,
        accountNumbers,
        loadingAccountNumber,
        accountTransactionDrafts,
        loading
    } = useSelector(state => ({
        companies: state.Company.companies,
        loadingCompany: state.Company.loading,
        periods: state.Period.periods,
        loadingPeriod: state.Period.loading,
        accounts: state.Account.listAccount,
        loadingAccount: state.Account.loading,
        accountNumbers: state.AccountNumber.listAccountNumber,
        loadingAccountNumber: state.AccountNumber.loading,
        accountTransactionDrafts: state.AccountTransaction.listAccountTransactionDraft,
        loading: state.AccountTransaction.loadingDraft,
    }));

    const listRef = useRef(accountTransactionDrafts);

    useEffect(() => {
        listRef.current = accountTransactionDrafts;
    }, [accountTransactionDrafts]);

    const selectedRowChange = function () {
        let count = 0;
        listRef.current.forEach(item => {
            if (item.selected) {
                count++;
            }
        });
        setTotalSelected(count);
    };

    const handleSelectRow = function (event, idx) {
        const { checked } = event.target;
        listRef.current[idx].selected = checked;
        selectedRowChange();
    }

    const columns = useMemo(
        () => [
            {
                Header: '',
                accessor: 'action',
                textAlign: 'text-center',
                headerAlign: 'text-center',
                disableFilters: true,
                Cell: (cellProps) => {
                    return (<Input
                        type="checkbox"
                        className="form-check-Input"
                        checked={cellProps.value}
                        onChange={(e) => handleSelectRow(e, cellProps.row.index)}
                    />);
                }
            },
            {
                Header: 'Period',
                accessor: 'period.name',
                textAlign: 'text-center',
                headerAlign: 'text-center',
                disableFilters: true,
                Cell: (cellProps) => {
                    return cellProps.value;
                }
            },
            {
                Header: 'Date',
                accessor: 'dateStr',
                textAlign: 'text-center',
                headerAlign: 'text-center',
                disableFilters: true,
                Cell: (cellProps) => {
                    return cellProps.value;
                }
            },
            {
                Header: 'Remarks',
                accessor: 'remarks',
                textAlign: 'text-start',
                headerAlign: 'text-start',
                disableFilters: true,
                Cell: (cellProps) => {
                    return cellProps.value;
                }
            },
            {
                Header: 'Account Number',
                accessor: 'accountNumber.name',
                textAlign: 'text-start',
                headerAlign: 'text-center',
                disableFilters: true,
                Cell: (cellProps) => {
                    return cellProps.value;
                }
            },
            {
                Header: 'Type',
                accessor: 'type',
                textAlign: 'text-center',
                headerAlign: 'text-center',
                disableFilters: true,
                Cell: (cellProps) => {
                    return upperCase(cellProps.value);
                }
            },
            {
                Header: 'Nominal',
                accessor: 'nominal',
                textAlign: 'text-end',
                headerAlign: 'text-end',
                disableFilters: true,
                Cell: (cellProps) => {
                    return <CurrencyFormat value={cellProps.value} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0}
                        displayType={'text'} />;
                }
            }
        ],
        []
    );

    const onRefreshCommand = () => {
        if (selectedCompany && selectedPeriod) {
            dispatch(onGetAccountTransactionDrafts({
                companyId: selectedCompany ? selectedCompany.value : null,
                periodId: selectedPeriod ? selectedPeriod.value : null,
                accountNumberId: selectedAccountNumber ? selectedAccountNumber.value : null,
                tglMulai: tglMulaiFilter && tglSampaiFilter ? tglMulaiFilter : null,
                tglSampai: tglMulaiFilter && tglSampaiFilter ? tglSampaiFilter : null,
                type: selectedType ? selectedType.value : null,
                remarks: remarks ? remarks : null,
            }));
        }
    }

    const onResetFilterCommand = () => {
        filterCompany.current.clearValue();
        filterPeriod.current.clearValue();
        filterAccountNumber.current.clearValue();
        filterDateRange.current.flatpickr.clear();
        filterType.current.clearValue();
        filterRemarks.current.value = null;
        setRemarks(null)
    }

    const onOpenDeleteCommand = () => {
        setIsOpenDelete(true);
    }

    const onDeleteCommand = () => {
        setIsDeleting(true);
        dispatch(onDeleteAccountTransactionDraft(listRef.current
            .filter(item => item.selected)
            .map(item => {
                return { id: item.id, companyId: item.companyId, accountNumberId: item. accountNumberId, periodId: item.periodId };
            }), function (status) {
                setIsDeleting(false);
                setIsOpenDelete(false)
                if (status) {
                    onRefreshCommand();
                }
            }))
    }

    const footer = () => {

        if (accountTransactionDrafts && accountTransactionDrafts.length > 0) {
            const totalNominal = accountTransactionDrafts.reduce((total, cur) => total + cur.nominal, 0);
            return <tfoot className="table-light table-nowrap">
                <tr>
                    <td colSpan={6}>Total</td>
                    <td className="text-end">
                        <CurrencyFormat value={totalNominal} displayType={'text'} decimalScale={0} thousandSeparator={'.'} decimalSeparator={','} />
                    </td>
                </tr>
            </tfoot>
        }
        return null
    }

    useEffect(() => {
        onRefreshCommand();
    }, [dispatch]);

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map((item) => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [companies])
    useEffect(() => {
        if (periods) {
            setOptionPeriod(periods.map((item) => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [periods])
    useEffect(() => {
        if (accountNumbers) {
            setOptionAccountNumber(accountNumbers.map((item) => {
                return { label: item.name + ' - ' + item.number, value: item.id }
            }))
        }
    }, [accountNumbers])

    useEffect(() => {
        if (selectedCompany) {
            dispatch(onClearPeriods())
            dispatch(onClearListAccount())
            dispatch(onClearListAccountNumber())
            dispatch(onClearListAccountTransactionDraft())
            dispatch(onGetPeriods({ companyId: selectedCompany.value }));
            dispatch(onGetAccounts({ companyId: selectedCompany.value }));
            dispatch(onGetAccountNumbers({ companyId: selectedCompany.value }));
        }
    }, [selectedCompany])

    useEffect(() => {
        if (!selectedCompany || !selectedPeriod) {
            dispatch(onClearListAccountTransactionDraft());
        }
    }, [selectedCompany, selectedPeriod])

    const onExportExcel = () => {
        if (selectedCompany && selectedPeriod) {
            dispatch(onExportExcelAccountTransaction({
                companyId: selectedCompany ? selectedCompany.value : null,
                periodId: selectedPeriod ? selectedPeriod.value : null,
                accountNumberId: selectedAccountNumber ? selectedAccountNumber.value : null,
                tglMulai: tglMulaiFilter && tglSampaiFilter ? tglMulaiFilter : null,
                tglSampai: tglMulaiFilter && tglSampaiFilter ? tglSampaiFilter : null,
            }))
        }
    }

    useEffect(() => {
        selectedRowChange();
    }, [accountTransactionDrafts])

    useEffect(() => {
        dispatch(onGetCompanies({}));
    }, [])

    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    const [dataEdit, setDataEdit] = useState([])

    const onSubmitEdit = function (dataSubmit) {
        setIsSubmitting(true);
        dispatch(onUpdateAccountTransactionDraft(dataSubmit, function (status) {
            setIsSubmitting(false);
            if (status) {
                setIsOpenEdit(false);
                onRefreshCommand();
            }
        }));
    }

    const onEditCommand = function () {
        setDataEdit(listRef.current
            .filter(item => item.selected)
            .map((item) => {
                const selectedAccountNumber = optionAccountNumber.filter(s => s.value == item.accountNumberId);
                const selectedType = optionType.filter(s => s.value == item.type);
                const selectedPeriod = optionPeriod.filter(s => s.value == item.periodId);
                return {
                    ...item,
                    selectedAccountNumber: selectedAccountNumber.length > 0 ? selectedAccountNumber[0] : null,
                    selectedType: selectedType.length > 0 ? selectedType[0] : null,
                    selectedPeriod: selectedPeriod.length > 0 ? selectedPeriod[0] : null,
                    selectedAccount: null,
                };
            }
            ));
        setIsOpenEdit(true);
    };

    return (
        <React.Fragment>
            <ModalEdit show={isOpenEdit} onSubmit={onSubmitEdit} onCancel={() => setIsOpenEdit(false)} data={dataEdit} submitting={isSubmitting} />
            <DeleteModal show={isOpenDelete} onDeleteClick={onDeleteCommand} onCloseClick={() => setIsOpenDelete(false)} loadingDelete={isDeleting} />
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Transaction" breadcrumbItem="Draft Transaction's List" />
                    <Row className="mb-3">
                        <Col xs="12">
                            <Card>
                                <CardBody className="pt-0">
                                    <CardTitle className="my-3">Filter</CardTitle>
                                    <Row>
                                        <Col className="col-12 col-sm-4">
                                            <div>
                                                <Label>Company</Label>
                                                <Select
                                                    value={selectedCompany}
                                                    onChange={handleSelectCompany}
                                                    options={optionCompany}
                                                    isLoading={loadingCompany}
                                                    isClearable={true}
                                                    ref={filterCompany}
                                                    className="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                        <Col className="col-12 col-sm-4">
                                            <div>
                                                <Label>Period</Label>
                                                <Select
                                                    value={selectedPeriod}
                                                    onChange={handleSelectPeriod}
                                                    options={optionPeriod}
                                                    isLoading={loadingPeriod}
                                                    isClearable={true}
                                                    ref={filterPeriod}
                                                    className="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                        <Col sm={4}>
                                            <Label>Type</Label>
                                            <Select
                                                value={selectedType}
                                                onChange={handleSelectType}
                                                options={optionType}
                                                isClearable={true}
                                                ref={filterType}
                                                className="select2-selection"
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col className="col-12 col-sm-4">
                                            <div>
                                                <Label>Account Number</Label>
                                                <Select
                                                    value={selectedAccountNumber}
                                                    onChange={handleSelectAccountNumber}
                                                    options={optionAccountNumber}
                                                    isLoading={loadingAccountNumber}
                                                    isClearable={true}
                                                    ref={filterAccountNumber}
                                                    className="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                        <Col className="col-12 col-sm-4">
                                            <Label>Date Range</Label>
                                            <Flatpickr
                                                className="form-control d-block"
                                                placeholder="Select Date"
                                                options={{
                                                    mode: "range",
                                                    dateFormat: "Y-m-d"
                                                }}
                                                onChange={handleDateRangeChange}
                                                ref={filterDateRange}
                                            />
                                        </Col>
                                        <Col className="col-12 col-sm-4">
                                            <div>
                                                <Label>Remarks</Label>
                                                <Input
                                                    type="text"
                                                    value={remarks}
                                                    className="form-control"
                                                    innerRef={filterRemarks}
                                                    onChange={e => {
                                                        setRemarks(e.target.value)
                                                    }}
                                                    placeholder={'Enter ...'}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col className="justify-content-end">
                                            <Button color="primary" className="btn btn-primary waves-effect waves-light  float-end" style={{ minWidth: '200px' }}
                                                disabled={loading}
                                                onClick={onRefreshCommand}>
                                                <i className="bx bx-filter-alt"></i>
                                            </Button>
                                            <Button color="info" className="btn btn-info waves-effect waves-light me-2 float-end" style={{ minWidth: '100px' }}
                                                disabled={loading}
                                                onClick={onResetFilterCommand}>
                                                Clear
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <div className="d-flex mb-2">
                                        <div className="flex-grow-1">

                                        </div>
                                        <Button color="info" className="btn btn-primary waves-effect waves-light me-2" disabled={totalSelected <= 0} onClick={onEditCommand}>
                                            Edit Selected ({totalSelected})
                                        </Button>
                                        <Button color="info" className="btn btn-danger waves-effect waves-light" disabled={totalSelected <= 0} onClick={onOpenDeleteCommand}>
                                            Delete Selected ({totalSelected})
                                        </Button>
                                    </div>
                                    {
                                        !loading && selectedCompany &&
                                        <>
                                            <TableContainer
                                                columns={columns}
                                                data={accountTransactionDrafts}
                                                isGlobalFilter={false}
                                                customPageSize={10}
                                                footer={footer}
                                            />
                                        </>
                                    }
                                    {
                                        !loading && (!selectedCompany || !selectedPeriod) &&
                                        <div className="d-flex justify-content-center my-5">
                                            <p>Please select company and period.</p>
                                        </div>
                                    }
                                    {
                                        loading &&
                                        <div className="d-flex justify-content-center my-5">
                                            <PulseLoader loading={loading} color={'#FFF'} size={12} className="align-self-center" />
                                        </div>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

AccountClassification.propTypes = {
    accounts: PropTypes.array,
    className: PropTypes.string,
    onGetCompanies: PropTypes.func,
    onGetPeriods: PropTypes.func,
    onGetAccountNumbers: PropTypes.func,
    onGetAccountTransactions: PropTypes.func,
    preGlobalFilteredRows: PropTypes.any,
};

export default AccountClassification
